import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class CustomIconService {

  public initialized: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  private icons: string[] = [
    'google.svg',
    'microsoft.svg',
    'keycloak.svg',
    'ping.svg'
  ]

  constructor(private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer) {
    this.icons.forEach(icon => {
      this.matIconRegistry.addSvgIcon(
        this.getIconWithoutExtension(icon),
        this.domSanitizer.bypassSecurityTrustResourceUrl(`./assets/icons/${icon}`));
    });

    this.initialized.next(true);

  }

  private getIconWithoutExtension(icon: string): string {
    return icon?.split(".")[0];
  }
}
